module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-page-navigation-rigth-arrow-disabled.ef1ad5e9.svg";